import React from 'react';

import './RadioButtons.scss';

const RadioButtons = (props) => (
    <div className={props.parentClassName}>
        {props.options.map((button, index) => (
            <div className={`radio-button ${props.className}`} key={index} onClick={() => props.changeChoice(button)}>
                <div className="button">
                    {props.value === button ? <div className="active"></div> : ''}
                </div>
                {
                    typeof button === 'string' ?
                    <div className="text">button</div> :
                    <div className="text">{button.name}<sub>{button.label}</sub></div>
                }
            </div>
        ))}
    </div>
);

export default RadioButtons;